import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import LoanTapeTypes from './LoanTapeTypes'
import CreateLoanTapeType from './CreateLoanTapeType'
import LoanTapeType from './LoanTapeType'

const LoanTapeTypesRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <LoanTapeTypes />
      </Route>

      <Route path={`${path}/create`}>
        <CreateLoanTapeType />
      </Route>

      <Route path={`${path}/:loanTapeTypeId`}>
        <LoanTapeType />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default LoanTapeTypesRoutes
